import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
const DashboardDefault = Loadable(
  lazy(() => import('views/dashboard/Default'))
);
// Department routing
const Department = Loadable(
  lazy(() => import('views/dashboard/Deparment/Department'))
);
const User = Loadable(lazy(() => import('views/dashboard/User/User')));
const Action = Loadable(lazy(() => import('views/dashboard/Action/Action')));
const AllActions = Loadable(
  lazy(() => import('views/dashboard/AllActions/AllActions'))
);
const DepartmentAction = Loadable(
  lazy(() => import('views/dashboard/DepartmentAction/DepartmentAction'))
);
const SubAction = Loadable(
  lazy(() => import('views/dashboard/SubAction/SubAction'))
);

// utilities routing
const UtilsTypography = Loadable(
  lazy(() => import('views/utilities/Typography'))
);
const UtilsColor = Loadable(lazy(() => import('views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(
  lazy(() => import('views/utilities/MaterialIcons'))
);
const UtilsTablerIcons = Loadable(
  lazy(() => import('views/utilities/TablerIcons'))
);

// sample page routing
const SamplePage = Loadable(lazy(() => import('views/sample-page')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <DashboardDefault />,
    },
    {
      path: 'dashboard',
      element: <DashboardDefault />,
      children: [
        {
          path: 'default',
          element: <DashboardDefault />,
        },
      ],
    },
    {
      path: 'dashboard',

      children: [
        {
          path: 'action',
          element: <Action />,
        },
      ],
    },
    {
      path: 'dashboard',

      children: [
        {
          path: 'department-action',
          element: <DepartmentAction />,
        },
      ],
    },
    {
      path: 'dashboard',

      children: [
        {
          path: 'department-action/subaction/:actionId/:deptId',
          element: <SubAction />,
        },
      ],
    },

    {
      path: 'dashboard',

      children: [
        {
          path: 'department',
          element: <Department />,
        },
      ],
    },
    {
      path: 'dashboard',

      children: [
        {
          path: 'user',
          element: <User />,
        },
      ],
    },
    {
      path: 'dashboard',

      children: [
        {
          path: 'all-actions',
          element: <AllActions />,
        },
      ],
    },

    // {
    //   path: "utils",
    //   children: [
    //     {
    //       path: "util-typography",
    //       element: <UtilsTypography />,
    //     },
    //   ],
    // },
    // {
    //   path: "utils",
    //   children: [
    //     {
    //       path: "util-color",
    //       element: <UtilsColor />,
    //     },
    //   ],
    // },
    // {
    //   path: "utils",
    //   children: [
    //     {
    //       path: "util-shadow",
    //       element: <UtilsShadow />,
    //     },
    //   ],
    // },
    // {
    //   path: "icons",
    //   children: [
    //     {
    //       path: "tabler-icons",
    //       element: <UtilsTablerIcons />,
    //     },
    //   ],
    // },
    // {
    //   path: "icons",
    //   children: [
    //     {
    //       path: "material-icons",
    //       element: <UtilsMaterialIcons />,
    //     },
    //   ],
    // },
    // {
    //   path: "sample-page",
    //   element: <SamplePage />,
    // },
  ],
};

export default MainRoutes;
